import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material'
import React from 'react'

import Chip from '@/components/Chip'
import { isNullorEmpty } from '@/utils'
import { pieChartSections } from '@/utils/constants'

const TableHeader = ({ text }: { text: string }) => (
  <TableCell
    sx={{
      p: '16px',
      textAlign: 'left',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.17px',
      fontWeight: '500',
      background: 'rgba(0, 0, 0, 0.00)',
    }}
  >
    {text}
  </TableCell>
)

const TableData = ({ value }: { value: string | undefined }) => (
  <TableCell
    sx={{
      p: '16px',
      textAlign: 'left',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.17px',
      fontWeight: '400',
      background: 'rgba(0, 0, 0, 0.00)',
    }}
  >
    {value ? `${value}` : '-'}
  </TableCell>
)

function EnamelRecipe({
  brand,
  recipeOutput,
}: {
  brand: string
  recipeOutput: any
}) {
  const theme = useTheme()

  const updatedList = pieChartSections?.filter((item) => item)
  return (
    <Box
      display="flex"
      flexDirection="column"
      padding="32px"
      height="100%"
      borderRadius="8px"
      gap="24px"
      sx={{ color: 'white', backgroundColor: '#292929' }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Typography sx={{ fontSize: '1.25rem', fontWeight: 500 }}>
          Enamel:
        </Typography>
        {isNullorEmpty(brand) && (
          <Chip
            label={brand}
            sx={{
              bgcolor: theme.palette.background.chip,
              color: theme.palette.common.black,
              '&:hover': {
                bgcolor: theme.palette.background.chip,
              },
            }}
          />
        )}
      </Box>
      <Table
        sx={{
          width: '100%',
          borderCollapse: 'unset',
          background: '#292929',
        }}
      >
        <TableBody>
          <TableRow>
            <TableHeader text="Head" />
            {updatedList?.map(({ key, label }) => (
              <React.Fragment key={key}>
                <TableHeader text={label} />
              </React.Fragment>
            ))}
          </TableRow>
          <TableRow>
            <TableData value="Enamel" />
            {updatedList?.map(({ key }) => {
              const chartDetail = recipeOutput?.[`enameloptions_${key}`] || ''
              return (
                <React.Fragment key={key}>
                  <TableData value={chartDetail} />
                </React.Fragment>
              )
            })}
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  )
}

export default EnamelRecipe
